import DIApi from './_diApi';

class OrganizationUnitAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'organizationunit';
}

export default new OrganizationUnitAPI();
